import api from './api'

export const veterinarioService = {
  async getAll(params = {}) {
    const response = await api.get('/veterinarios', { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/veterinarios/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post('/veterinarios', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/veterinarios/${id}`, data)
    return response.data
  },

  // Soft delete - marca como eliminado
  async delete(id) {
    const response = await api.delete(`/veterinarios/${id}`)
    return response.data
  },

  // Obtener veterinarios disponibles (inactivos) para contratar
  async getDisponibles(params = {}) {
    const response = await api.get('/veterinarios/disponibles', { params })
    return response.data
  },

  // Contratar/reasignar un veterinario disponible a una clínica
  async contratar(id, data = {}) {
    const response = await api.post(`/veterinarios/${id}/contratar`, data)
    return response.data
  },
}

